import DaftarNilai from '../../../views/Kurikulum/Ulangan/DaftarNilai.view';
import { connect } from 'react-redux';
import { getStudent } from '../../../states/thunks/student.thunk';
import { getClasses, getParamOptionsAcademics, getSubjectOptions, getLevels, getPeriodsOptions, getTypeExam, getParamOptions, 
        getTeacherSubjectsOptions, getTypeExamScoreList, getClassesOptions, getPrmLevels } from '../../../states/thunks/options.thunk';
import { listScoreStudents, saveCognitiveValue, editNilaiKognitif, getNilaiKognitif, listNilaiKognitif, listPsikAfek, listTypeExam, saveScoreList } from '../../../states/thunks/academics.thunk';


function mapStateToProps(state){
    return{
        classes: state.options.classes,
        result: state.result,
        user: state.user || {},
        levels: state.options.levels,
    }
    
}

function mapDispatchToProps(dispatch){
    return{
        handleGetClasses: payload => dispatch(getClasses(payload)),
        handleGetStudent: () => dispatch(getStudent()),
        handleGetLevels: payload => dispatch(getLevels(payload)),
        getSubjectOptions: (payload) => dispatch(getSubjectOptions(payload)),
        getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
        handleListNilaiKognitif: (payload, goback) => dispatch(listNilaiKognitif(payload, goback)),
        handleListPsikAfek: (payload, goback) => dispatch(listPsikAfek(payload, goback)),
        getPeriodsOptions: (payload) => dispatch(getPeriodsOptions(payload)),
        getTypeExam: (payload) => dispatch(getTypeExam(payload)),
        getTeacherSubjectsOptions: (payload) => dispatch(getTeacherSubjectsOptions(payload)),
        getParamOptions: (payload, type) => dispatch(getParamOptions(payload, type)),
        handleListScoreStudents: (payload, goback) => dispatch(listScoreStudents(payload, goback)),
        handleSaveCognitiveValue: (payload, goback) => dispatch(saveCognitiveValue(payload, goback)),
        handleEditNilaiKognitif: (payload, goBack) => dispatch(editNilaiKognitif(payload, goBack)),
        handleGetNilaiKognitif: payload => dispatch(getNilaiKognitif(payload)),
        getTypeExamScoreList: (payload) => dispatch(getTypeExamScoreList(payload)),
        handleListTypeExam: (payload, goback) => dispatch(listTypeExam(payload, goback)),
        handlesaveScoreList: (payload, goback) => dispatch(saveScoreList(payload, goback)),
        getClassesOptions: (payload) => dispatch(getClassesOptions(payload)),
        getPrmLevels: (payload) => dispatch(getPrmLevels(payload)),
        
    };
}
export default connect(mapStateToProps, mapDispatchToProps) (DaftarNilai);